import { Injectable, Inject } from '@angular/core';

import { DataService }   from '../shared-service/data.service';
import { BaseService }   from '../shared-service/base.service';
// import { KeycloakService } from 'keycloak-angular';
//import 'rxjs/add/operator/toPromise';


@Injectable()
export class LoginService {

    constructor(public bs: BaseService,private dataService:DataService) {
        this.bs.log('info',"Loaded LoginService");
    }



    updateStoreData(key: PropertyKey, data: Object) {
        return this.dataService.setStoreData(key, data);
    }

    getStoreData(key: PropertyKey) {
        return this.dataService.getDataStoreData(key);
    }

    getLoginDetailFromServer(body: Object, key: PropertyKey, loginType: PropertyKey) {
        let promise = new Promise((resolve, reject) => {
			let controllerMethod:any;
			if(loginType == "freshLogin"){
				controllerMethod = 'Logon/ValidateLogin';
			} else {
				/*Login with jwt token*/
				controllerMethod = 'Logon/GetUserAccountDetail';
			}
            this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
                this.bs.log('info',"Succes in getting result from "+controllerMethod);
                resolve(data);
            }, (err) => {
                this.bs.log('error',err);
                this.bs.logout();
                this.bs.errorHandler((err.error).Message);
                reject((err.error).Message);
                
            }).catch((exception)=>{
                 this.bs.errorHandler(exception);
                reject(exception);
            });
        });
        return promise;
    };

    // Get user login details
   getUserMoreDetails(body: Object, key: PropertyKey){
        return new Promise((resolve, reject) => {
            this.dataService.doPostWithPromise(key, 'Logon/GetUser', body).then( (data) => {
                resolve(data);
            }, (err) => {
                this.bs.log('error',err);
                this.bs.logout();
                this.bs.errorHandler((err.error).Message);
                reject((err.error).Message);
                
            }).catch((exception)=>{
                 this.bs.errorHandler(exception);
                reject(exception);
            });
        });
    }
    
    getJwtWiseLoginDetailFromServer (body: Object, key: PropertyKey, loginType: PropertyKey) {
        let promise = new Promise((resolve, reject) => {
			let controllerMethod='Logon/GetJwtWiseUserAccountDetail';			
            this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
                this.bs.log('info',"Succes in getting result from "+controllerMethod);
                resolve(data);
            }, (err) => {
                this.bs.log('error',err);
                this.bs.logout();
                this.bs.errorHandler((err.error).Message);
                reject((err.error).Message);
                
            }).catch((exception)=>{
                 this.bs.errorHandler(exception);
                reject(exception);
            });
        });
        return promise;
    };

    getStringResourceFromServer (body: Object, key: PropertyKey) {

        let promise = new Promise((resolve, reject) => {
            let controllerMethod = 'Logon/GetStringResources';
            this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
                this.bs.log('info',"Succes in getting result from "+controllerMethod);
                resolve(data);
            }, (err) => {
                this.bs.log('error',err);
                 this.bs.errorHandler(JSON.parse(err.error).Message);
                reject(JSON.parse(err.error).Message);
            }).catch((exception)=>{
                 this.bs.errorHandler(exception);
                reject(exception);
            });
        });
        return promise;
    };

    
    getJwtWiseUserSpacedLearningDetail (body: Object, key: PropertyKey) {

        let promise = new Promise((resolve, reject) => {
            let controllerMethod = 'Logon/GetJwtWiseUserSpacedLearningDetail';
            this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
                this.bs.log('info',"Succes in getting result from "+controllerMethod);
                resolve(data);
            }, (err) => {
                this.bs.log('error',err);
                 this.bs.errorHandler(JSON.parse(err.error).Message);
                reject(JSON.parse(err.error).Message);
            }).catch((exception)=>{
                 this.bs.errorHandler(exception);
                reject(exception);
            });
        });
        return promise;
    };

    loginInAdminSite (body: Object|any, key: PropertyKey) {
        return new Promise((resolve, reject) => {
            let controllerMethod = 'Default.aspx?UserId='+body['UserId']+'&jwtToken='+body['jwtToken']+'&CourseLaunchId='+body['CourseLaunchId']+'&nodeId='+body['nodeId'];
            this.dataService.doPostWithPromise(key, controllerMethod, body).then( (data) => {
                //resolve(data);
            }, (err) => {
                //reject(JSON.parse(err.error).Message);
            });
        });
    };

    getStoreLoginData(key: PropertyKey) {
        return this.dataService.getDataStoreData(key);
    }; 
    
    
    // Get user login details
    canUserLogin(body: Object, key: PropertyKey){
    return new Promise((resolve, reject) => {
        this.dataService.doPostWithPromise(key, 'Logon/CanUserLogin', body).then( (data) => {
            resolve(data);
        }, (err) => {
            this.bs.log('error',err);
            this.bs.logout();
            this.bs.errorHandler((err.error).Message);
            reject((err.error).Message);
            
        }).catch((exception)=>{
             this.bs.errorHandler(exception);
            reject(exception);
        });
    });
}
}

